/* istanbul ignore file */
import { createReducer } from "sc/helpers/reducer";
import { RECEIVED_UNSTABLE_FEATURES_STATUS } from "../actions/unstable-features-status";

let defaultConfig = { retrieved: false, unstableFeatures: {} };

export const setUnstableFeatures = unstableFeatures => {
  defaultConfig = { retrieved: true, unstableFeatures };
};

export const createUnstableFeaturesStatusReducer = () =>
  createReducer(defaultConfig, {
    [RECEIVED_UNSTABLE_FEATURES_STATUS]: (state, action) =>
      JSON.stringify(state) === JSON.stringify(action.payload)
        ? state
        : action.payload,
  });



// WEBPACK FOOTER //
// ./src/sc/reducers/unstable-features-status.js